<p-panel>
  <div class="d-flex flex-wrap justify-content-between">
    <div style="flex: 2" class="mr-4">
      <app-reactive-form-builder
            #builderRef
            [form]="form.formFields"
            [id]="getRegisterId().toString()"
            [request]="getType() === 1 ? tratamientosApi.tratamientosManez.PUT : tratamientosApi.tratamientosManez.POST"
            [getRequest]="tratamientosApi.tratamientosManez.GET"
            [previousData]="initialPreviousData"
            [dropdownLoadTrigger]="dropdownLoadTrigger"
            [dropdownsFinalized]="dropdownsFinalized"
            (formChanges)="formChanges($event[0], $event[1])"
            (goBack)="goBack()">
      </app-reactive-form-builder>
    </div>

    <div style="flex: 1">
      <h4 class="mb-3">Productos</h4>

      <div class="d-flex justify-content-between mb-2">
        <div style="flex: 1;"></div>
        <div class="mr-2 font-weight-bold" style="flex: 4;">
          <span>Nombre</span>
        </div>
        <div class="font-weight-bold" style="flex: 2;">
          <span>Dosis&nbsp;(%)</span>
        </div>
        <div class="ml-2 font-weight-bold" style="flex: 2;">
          <span>Unidades</span>
        </div>
      </div>

      <div *ngFor="let i of productIndexes; let productIndex = index" class="d-flex justify-content-between mb-3">
        <div style="flex: 1">
          {{ i }}
        </div>
        <div class="mr-2" style="flex: 4;">
          <p-select
            *ngIf="productosAll"
            [filter]="true"
            [formControl]="getProductControl(productIndex)"
            [options]="productosAll.filtered"
            optionLabel="label"
            optionValue="value"
            appendTo="body"
            (onChange)="onProductChange()">
          </p-select>
        </div>
        <div style="flex: 2">
          <input
            [id]="'dosis' + i"
            type="number"
            [formControl]="getDoseControl(productIndex)"
            (input)="onDoseChange()" />
        </div>
        <div class="ml-2" style="flex: 2">
          <span *ngIf="model?.productos_uds">
            {{ model.productos_uds?.[productIndex] }}
          </span>
        </div>
      </div>
    </div>
  </div>

  <div>
    <div class="my-4 text-center">
      <table class="registro-table table-bordered">
        <tr>
          <td class="font-weight-bold" style="width: 160px;">PRESIÓN (BAR)</td>
          <td *ngFor="let i of [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20]">
            {{ i }}
          </td>
        </tr>
        <tr class="font-weight-bold">
          <td>Caudal (l/min)</td>
          <td *ngFor="let i of [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20]">
            {{ totalCaudales[i] || 0.00 }}
          </td>
        </tr>
      </table>
    </div>
  </div>
</p-panel>
